import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('blob', '/blobs')
const actions = generator.generate()

export default actions
